import { useRouter } from "next/navigation";
import { trackEvent } from "@/utils/analytics";
import { EVENT_CATEGORY, EVENT_ACTION } from "@/constants/constants";

interface RedirectRequest {
    path: string;
    event_name?: string;
    event_source?: string;
}

const useRedirect = () => {
    const router = useRouter();
    const searchParams = window.location.search;

    const handleRedirect = (req: RedirectRequest) => {
        if (req.event_name) {
            trackEvent({
                event_name: req.event_name,
                category: EVENT_CATEGORY.NAVIGATION,
                action: EVENT_ACTION.CLICK,
                label: req.event_source,
            });
        }
        router.push(`${req.path}${searchParams}`);
    };

    return { handleRedirect };
};

export default useRedirect;
